import { Component, Input, TemplateRef } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';

export interface ISharePointFileLintCardItem {
  name: string;
  webUrl: URL;
  sharePointSiteUrl: URL;
}

@Component({
  selector: 'em-share-point-file-link-card',
  styleUrls: ['./share-point-file-link-card.component.less'],
  templateUrl: './share-point-file-link-card.component.html',
  standalone: false,
})
export class SharePointFileLinkCardComponent {
  @Input() public loading = false;
  @Input() public error = '';
  @Input() public title = '';
  @Input() public item?: ISharePointFileLintCardItem;
  @Input() public cardDescription?: TemplateRef<void> | string;

  public readonly trackByRef = trackByRef;
}
